import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const medicationsSelector = (state: RootState) => state.amwell.activeConsumer.medications;

export const medicationsDataSelector = createSelector(medicationsSelector, m => m.list.data);
export const medicationsDataErrorSelector = createSelector(medicationsSelector, m => m.list.error);
export const medicationsDataLoadingSelector = createSelector(
  medicationsSelector,
  m => m.list.loading
);

export const medicationsActionLoadingSelector = createSelector(
  medicationsSelector,
  m => m.action.loading
);
export const medicationsActionErrorSelector = createSelector(
  medicationsSelector,
  m => m.action.error
);

export const searchMedicationsDataSelector = createSelector(
  medicationsSelector,
  m => m.search.data
);
export const searchMedicationsDataErrorSelector = createSelector(
  medicationsSelector,
  m => m.search.error
);
export const searchMedicationsDataLoadingSelector = createSelector(
  medicationsSelector,
  m => m.search.loading
);
